import { servicesEnum } from './_types';

const FIELDS = {
  service: {
    label: 'Servicio:',
    rules: { required: true },
    validationMessages: { required: 'El servicio es requerido.' },
  },
  other: {
    label: 'Otro:',
    rules: { required: true },
    validationMessages: { required: 'Favor especifique otra(s).' },
  },
  modality: {
    label: 'Modalidad:',
    rules: { required: true },
    validationMessages: { required: 'La modalidad es requerida.' },
  },
  frequency: {
    label: 'Frecuencia:',
    rules: { required: true },
    validationMessages: { required: 'La frecuencia es requerida.' },
  },
  duration: {
    label: 'Duración:',
    rules: { required: true },
    validationMessages: { required: 'La duración es requerida.' },
  },
  dutyTime: {
    label: 'Tiempo en el Servicio (meses):',
    rules: { required: true },
    validationMessages: { required: 'El tiempo en el servicio es requerido.' },
  },
  approach: {
    label: 'Tipo de Enfoque:',
    rules: { required: true },
    validationMessages: { required: 'El tipo de enfoque es requerido.' },
  },
  teacher: {
    label: 'Tipo de Maestro:',
    rules: { required: true },
    validationMessages: { required: 'El tipo de maestro es requerido.' },
  },
  equipment: {
    label: 'Equipos Asignados:',
    rules: { required: true },
    validationMessages: {
      required: 'Equipo(s) asignado(s) es(son) requerido(s).',
    },
  },
  place: {
    label: 'Lugar donde se utiliza el equipo:',
    rules: { required: true },
    validationMessages: {
      required: 'El lugar donde se utiliza el equipo es requerido.',
    },
  },
  comment: {
    label: 'Comentario:',
    rules: { required: true },
    validationMessages: { required: 'El comentario es requerido.' },
  },
};

export const relatedServicesConfig = {
  title: 'Servicios Relacionados',
  schema: {
    service: {
      ...FIELDS.service,
      displayKey: 'name',
      replaceIf: {
        property: 'other',
        ownProperty: { name: 'id', equals: servicesEnum.Otros },
        prependText: FIELDS.other.label + ' ',
      },
    },
    other: {
      ...FIELDS.other,
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [servicesEnum.Otros],
      },
      hideInDetail: true,
    },
    modality: { ...FIELDS.modality, displayKey: 'name' },
    frequency: { ...FIELDS.frequency, displayKey: 'name' },
    duration: { ...FIELDS.duration, displayKey: 'name' },
    dutyTime: FIELDS.dutyTime,
    comment: FIELDS.comment,
  },
};

export const supplementaryServicesConfig = {
  title: 'Servicios Suplementarios',
  schema: {
    service: {
      ...FIELDS.service,
      displayKey: 'name',
      replaceIf: {
        property: 'other',
        ownProperty: { name: 'id', equals: servicesEnum.Otros },
        prependText: FIELDS.other.label + ' ',
      },
    },
    other: {
      ...FIELDS.other,
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [servicesEnum.Otros],
      },
      hideInDetail: true,
    },
    modality: {
      ...FIELDS.modality,
      displayKey: 'name',
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [
          servicesEnum.Educativo,
          servicesEnum['Educación Física Adaptada'],
          servicesEnum['Educación Física Adaptada/Combinada'],
        ],
      },
    },
    approach: {
      ...FIELDS.approach,
      displayKey: 'name',
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [servicesEnum.Educativo],
      },
    },
    frequency: {
      ...FIELDS.frequency,
      displayKey: 'name',
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [
          servicesEnum['Educación Física Adaptada'],
          servicesEnum['Educación Física Adaptada/Combinada'],
          servicesEnum.Educativo,
          servicesEnum['Servicio para Ciegos'],
          servicesEnum['Servicio para Sordos'],
        ],
      },
    },
    duration: {
      ...FIELDS.duration,
      displayKey: 'name',
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [
          servicesEnum['Educación Física Adaptada'],
          servicesEnum['Educación Física Adaptada/Combinada'],
          servicesEnum.Educativo,
          servicesEnum['Servicio para Ciegos'],
          servicesEnum['Servicio para Sordos'],
        ],
      },
    },
    dutyTime: {
      ...FIELDS.dutyTime,
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [
          servicesEnum['Educación Física Adaptada'],
          servicesEnum['Educación Física Adaptada/Combinada'],
          servicesEnum.Educativo,
          servicesEnum['Servicio para Ciegos'],
          servicesEnum['Servicio para Sordos'],
        ],
      },
    },
    comment: FIELDS.comment,
    teacher: {
      ...FIELDS.teacher,
      displayKey: 'name',
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [
          servicesEnum['Educación Física Adaptada'],
          servicesEnum['Educación Física Adaptada/Combinada'],
          servicesEnum['Servicio para Ciegos'],
          servicesEnum['Servicio para Sordos'],
        ],
      },
    },
    equipment: {
      ...FIELDS.equipment,
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [servicesEnum['Asistencia Tecnológica']],
      },
    },
    place: {
      ...FIELDS.place,
      displayKey: 'name',
      visibleIf: {
        property: 'service',
        valueKey: 'id',
        includes: [servicesEnum['Asistencia Tecnológica']],
      },
    },
  },
};
